import { render } from "./ModuleInfoBlock.vue?vue&type=template&id=d90a3796"
import script from "./ModuleInfoBlock.vue?vue&type=script&lang=js"
export * from "./ModuleInfoBlock.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__